const lockScroll = () => {
  const body = document.querySelector('body');
  body.style.overflow = 'hidden';
};

const unlockScroll = () => {
  const body = document.querySelector('body');
  body.style.overflow = 'auto';
};

// Walks an HTML string as a DOM tree so tags aren't cut mid-element, stopping once wordLimit words
// have been kept. Keeps scanning past the cutoff (without building output) so word-less trailing
// nodes - e.g. an empty `<p><br></p>` spacer between rich-text paragraphs - don't leak into the
// result, and so a cutoff landing on the very last word doesn't get falsely flagged as truncated.
const truncateHtmlByWords = (html, wordLimit) => {
  const source = document.createElement('div');
  source.innerHTML = html;

  let wordCount = 0;
  let cutoff = false;
  let hasRemainingWords = false;
  let lastTextNode = null;

  const walk = (node) => {
    if (cutoff) {
      if (!hasRemainingWords && /\S/.test(node.textContent)) hasRemainingWords = true;
      return null;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      const tokens = node.textContent.split(/(\s+)/);
      let text = '';
      for (const token of tokens) {
        if (cutoff) {
          if (token !== '' && !/^\s+$/.test(token)) hasRemainingWords = true;
          continue;
        }
        if (token === '' || /^\s+$/.test(token)) {
          text += token;
          continue;
        }
        text += token;
        wordCount += 1;
        if (wordCount >= wordLimit) cutoff = true;
      }
      if (text === '') return null;
      const textNode = document.createTextNode(text);
      lastTextNode = textNode;
      return textNode;
    }

    const clone = node.cloneNode(false);
    for (const child of Array.from(node.childNodes)) {
      const childClone = walk(child);
      if (childClone) clone.appendChild(childClone);
    }
    return clone;
  };

  const result = document.createElement('div');
  for (const child of Array.from(source.childNodes)) {
    const clone = walk(child);
    if (clone) result.appendChild(clone);
  }

  if (hasRemainingWords && lastTextNode) {
    lastTextNode.textContent += '…';
  }

  return { html: result.innerHTML, truncated: hasRemainingWords };
};

// Truncates el's current HTML content to wordLimit words and wires up a read more/read less
// toggle button placed after el. Reads label text from el's data-read-more-text/data-read-less-text.
// Safe to call repeatedly on the same el (e.g. after a variant swap) - it replaces any prior toggle.
const applyReadMoreTruncation = (el, wordLimit = 75) => {
  if (!el) return;

  const existingToggle = el.parentElement?.querySelector('[data-read-more-toggle]');
  if (existingToggle) existingToggle.remove();

  const fullHtml = el.innerHTML;
  const { html: truncatedHtml, truncated } = truncateHtmlByWords(fullHtml, wordLimit);

  if (!truncated) return;

  const readMoreText = el.dataset.readMoreText || 'Read More';
  const readLessText = el.dataset.readLessText || 'Read Less';

  el.innerHTML = truncatedHtml;

  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.dataset.readMoreToggle = '';
  toggle.className = 'text-sm-medium underline mt-2 block';
  toggle.setAttribute('aria-expanded', 'false');
  toggle.textContent = readMoreText;

  toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    el.innerHTML = expanded ? truncatedHtml : fullHtml;
    toggle.setAttribute('aria-expanded', String(!expanded));
    toggle.textContent = expanded ? readMoreText : readLessText;
  });

  el.insertAdjacentElement('afterend', toggle);
};

export { lockScroll, unlockScroll, applyReadMoreTruncation };
